import { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [isCommandInProcessing, setIsCommandInProcessing] = useState(false);
  const [userType, setUserType] = useState(null);

  return (
    <UserContext.Provider value={{ loggedIn, setLoggedIn, userName, setUserName, isCommandInProcessing, setIsCommandInProcessing, userType, setUserType }}>
      {children}
    </UserContext.Provider>
  );
};